const en = {
  partners: {
    title: "Our",
    titleHighlight: "Partners",
    subtitle: "Trusted by leading fashion brands and retailers worldwide",
    trustedBy: "We Are Trusted By"
  },
  navigation: {
    home: "Home",
    download: "Download",
    support: "Support",
    privacy: "Privacy",
    validate: "Validate",
    resetPassword: "Reset Password",
    scanYourStyle: "SCAN YOUR STYLE",
    styleAnalysis: "STYLE ANALYSIS",
    aiAdvice: "AI ADVICE",
    downloadApp: "DOWNLOAD",
    aboutOutfino: "ABOUT OUTFINO",
    partners: "PARTNERS",
    awards: "AWARDS",
    news: "NEWS",
    features: "FEATURES",
    aboutApp: "ABOUT THE APP"
  },
  hero: {
    title: "We're writing the next",
    titleHighlight: "streetwear",
    titleSuffix: "story",
    subtitle: "Be part of our story.",
    getStarted: "Get Started",
    learnMore: "Learn More",
    styleTips: [
      "Air Jordan 1 Retro High OG Chicago Lost And Found = instant G.O.A.T.",
      "Add a Nike Tee to this, and you'll elevate your look 🔥",
      "Layer an oversize shirt over the hoodie – effortless drip achieved."
    ],
    scrollDown: "Scroll Down",
    aboutButton: "About Outfino"
  },
  features: {
    scan: {
      title: "🛍️ Drops & ",
      titleHighlight: "Brands",
      description: "Cop the sickest drops! Browse limited pieces from the biggest brands and shop directly from the app. Fresh releases, exclusive items and instant cops – everything that matters in streetwear, all in one place."
    },
    analysis: {
      title: "👕 Outfit of the ",
      titleHighlight: "Day",
      description: "Take a photo of your fit and compete in any of 11 categories – from streetwear to vintage to minimal. Compare your style with others, check out your friends' outfits, discover new looks and get inspired daily!",
      tags: {
        streetwear: "STREETWEAR",
        casual: "CASUAL", 
        urban: "URBAN",
        modern: "MODERN"
      }
    },
    ai: {
      title: "Meet our",
      titleHighlight: "AI model",
      description: "The app is powered by our own AI model that learns your style. The more you use it, the more personalized suggestions and product recommendations you'll receive.",
      chatMessages: {
        casual: "Try a relaxed-fit white tee with dark denim and fresh sneakers. Layer with a lightweight bomber for that perfect casual Friday vibe.",
        streetwear: "Oversized graphic hoodie, cargo pants, and chunky sneakers. Add chain accessories and a crossbody bag to complete the streetwear look.",
        jacket: "Based on your style, I recommend a vintage leather bomber or a minimalist denim jacket. Both versatile and timeless."
      },
      suggestions: {
        title: "Ask me about:",
        casualFriday: "Casual Friday",
        streetwear: "Streetwear", 
        perfectJacket: "Perfect Jacket"
      }
    }
  },
  support: {
    title: "NEED HELP?",
    alternativeText: "Or send an e-mail to",
    form: {
      name: "Name",
      email: "Email", 
      message: "Message",
      send: "Send",
      errors: {
        missing: "Something is missing!",
        invalidEmail: "E-mail is not valid!",
        failed: "Failed to send the message."
      },
      success: "Your message has been sent successfully!"
    }
  },
  awards: {
    title: "OUR AWARDS",
    items: {
      topStartup: {
        title: "#17 in AI",
        description: "Ranked #17 in F6S Top AI Companies list",
        year: "2025"
      },
      innovation: {
        title: "#1 in Fashion", 
        description: "Ranked #1 in F6S Top Fashion Companies list",
        year: "2025"
      },
      bestDesign: {
        title: "Best App Design",
        description: "Outstanding user experience and interface design", 
        year: "2025"
      }
    },
    viewOnF6S: "VIEW ON F6S"
  },
  newsletter: {
    title: "LATEST NEWS",
    readMore: "Read More",
    readLess: "Read Less",
    items: {
      aiUpdate: {
        title: "AI Style Assistant Gets Major Update",
        description: "Our AI-powered style assistant now features enhanced personalization algorithms, providing even more accurate fashion recommendations based on your unique preferences, body type, and lifestyle. The update includes real-time trend analysis and seasonal adjustments to keep your wardrobe fresh and relevant.",
        date: "Dec 15, 2024",
        category: "Product Update"
      },
      partnership: {
        title: "Outfino Partners with Major Fashion Brands",
        description: "We're excited to announce strategic partnerships with leading fashion retailers including Zara, H&M, and Nordstrom. This collaboration brings you exclusive discounts, early access to new collections, and seamless shopping integration directly within the Outfino app.",
        date: "Dec 10, 2024",
        category: "Partnership"
      },
      appFeature: {
        title: "New Virtual Fitting Room Feature",
        description: "Try before you buy with our revolutionary AR-powered virtual fitting room. See how clothes look on your body type, mix and match different pieces, and save your favorite outfits. This feature uses advanced 3D modeling to provide the most realistic fitting experience available.",
        date: "Dec 5, 2024",
        category: "Feature Release"
      },
      fashionWeek: {
        title: "Outfino at Paris Fashion Week 2025",
        description: "Join us at Paris Fashion Week where we'll be showcasing how technology is transforming personal style. Meet our team, experience live demos of our latest features, and get exclusive insights from top fashion designers about upcoming trends and the future of fashion tech.",
        date: "Nov 28, 2024",
        category: "Event"
      }
    },
    subscribe: {
      title: "Stay Updated",
      description: "Subscribe to our newsletter and never miss an update",
      emailPlaceholder: "Enter your email",
      button: "Subscribe"
    }
  },
  appDownload: {
    title: "Download the Outfino App",
    description: "Get personalized style recommendations on the go"
  },
  footer: {
    company: "Company",
    usefulLinks: "Useful Links",
    documents: "Documents", 
    connect: "Connect",
    links: {
      scanFriends: "Scan your friends",
      actualStyle: "Your actual style", 
      adviceFromAI: "Advice from AI",
      support: "Support",
      gdpr: "GDPR",
      privacyPolicy: "Privacy Policy"
    },
    copyright: "All rights reserved."
  },
  download: {
    title: "Download Our App",
    description: "Get the app on your device",
    downloadNow: "Download Now",
    availableOn: "Available on"
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated"
  },
  validation: {
    title: "Validation",
    validate: "Validate",
    enterCode: "Enter code",
    submit: "Submit"
  },
  resetPassword: {
    title: "Reset Password",
    email: "Email",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    resetButton: "Reset Password",
    backToLogin: "Back to Login"
  },
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    close: "Close",
    language: "Language"
  }
};

export default en;